


import React, { useContext } from "react"
import { Paper, Container, Divider, Tooltip } from "@material-ui/core"
import FlexView from "react-flexview/lib"
import { ReactComponent as ShieldSvg } from '../../assets/shield_with_v.svg';
import { ReactComponent as RenewSvg } from '../../assets/renew.svg';
import { ReactComponent as RenewSvgGray } from '../../assets/renew_powderblue.svg';
import './PolicySummary.scss'
import { InsurancePurchaseContextStore } from "../../context/InsuracePurchaseContext";
import { FirebaseService, FirebaseConfigKey } from "../../services/FirebaseService";
import { liabilityLimitPretty, billingPeriodPretty, isInFlow, KPretty } from "../../services/utils";
import dayjs from "dayjs";
import { DiscountTag } from "../Core/DiscountTag";
import {AntSwitch} from "../Core/Buttons/AntSwitch"
import { SessionContextStore } from "../../context/SessionContext";
import DiscountsService from "../../services/DiscountsService";
import { BuyingInsuranceContextStore } from "../../context/BuyingInsuranceContext";
import { COUNTRIES } from "../../Constants";
import LocalizationService from "../../services/LocalizationService";
import { COVERAGE_TYPES } from "../../models/insurance-models/CoverageType";
import { WorldWideOption } from "../../models/insurance-models/WorldWideOption";
import { isCanada } from '../../services/utils';



export const PolicySummary = (props) => {
    const insuranceContext = useContext(InsurancePurchaseContextStore)
    const sessionContext = useContext(SessionContextStore)
    const offersContext = useContext(BuyingInsuranceContextStore)

    let discount = DiscountsService.calculateDiscount(insuranceContext.selectedOption, sessionContext.user.totalDiscount, true /*TODO */ , insuranceContext.drones, insuranceContext.equipment)
    let title = billingPeriodPretty(insuranceContext.selectedOption.billingPeriod)
    const toggleAutoRenew = () => {
        insuranceContext.setAutoRenew(!insuranceContext.autoRenew)
    }
    return (
        <React.Fragment>
            <Paper elevation={3} className={`policy-summary-container${props.className ? " " + props.className: ""}`}>
                <div className={`policy-summary-headline${props.mobileExtension ? " policy-headline-no-border-radius" : ""}`}>
                    <FlexView className="space-between">
                        <FlexView vAlignContent={'center'}>
                            <ShieldSvg className="white-svg-path" />
                            <div className="white text-body bold margin-left-6">Your {title} Policy</div>
                        </FlexView>
                        <div>
                            <div className="text-tiny powderblue">Start date</div>
                            <div className="text-tiny powderblue">{dayjs(offersContext.subscriptionStartTime).format(FirebaseService.getValue(FirebaseConfigKey.LONG_DATE_FORMAT)) }</div>
                        </div>
                    </FlexView>
                </div>
                <Container className="margin-top-basic">
                    <div className="black text-small bold">Liability Limit</div>
                    {insuranceContext.selectedOption.liabilityLimitPremium != undefined && <FlexView className="margin-top-small space-between">
                        <div className="black text-tiny">{liabilityLimitPretty(insuranceContext.selectedOption.liabilityLimit)} Liability Limit</div>
                        <div className="black text-tiny">{FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}{discount.liability_price.toLocaleStringToFixed()}</div>
                    </FlexView>}

                    {/* {insuranceContext.selectedOption.liabilityLimitDiscount > 0 && <DiscountTag title={"Liability"} discountPercent={insuranceContext.selectedOption.liabilityLimitDiscountPercentage} discountPrice={insuranceContext.selectedOption.liabilityLimitDiscount.toLocaleStringToFixed()} />} */}
                    
                    <Divider />

                    {insuranceContext.selectedOption && insuranceContext.selectedOption.drones && (insuranceContext.selectedOption.drones.length > 0 || insuranceContext.selectedOption.equipment.length > 0) &&
                         (insuranceContext.selectedOption.dronePremium > 0 || insuranceContext.selectedOption.equipmentPremium > 0) &&
                         offersContext.coverageType == COVERAGE_TYPES.COMBINED &&
                    <React.Fragment>
                        <div className="black text-small bold">Physical Damage Coverage (Hull)</div>
                        {insuranceContext.selectedOption.drones.map( (drone, index) => <FlexView key={index} className="space-between margin-top-small">
                            <div className="black text-tiny">{drone.make} {drone.model}</div>
                            <div className="black text-tiny">{FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}{discount.drone_premiums_before_discount[index].toLocaleStringToFixed()}</div>
                        </FlexView>)}


                        {/* {discount.hull_percent > 0 && <DiscountTag title={"Drones"} discountPrice={discount.hull_reduction} discountPercent={discount.hull_percent} />} */}
                        {insuranceContext.selectedOption.equipment.map( (equip,index) => <FlexView key={index} className="space-between margin-top-small">
                            <div className="black text-tiny">{equip.quantity}x - {equip.type}</div>
                            <div className="black text-tiny">{FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}{discount.equipment_deductible[index].toFixed(2)}</div>
                        </FlexView>)}
                    
                        {/* {discount.hull_discount > 0 && <DiscountTag title={"Experience"} discountPercent={discount.hull_percent} discountPrice={discount.hull_discount} /> } */}
                        <Divider />
                    </React.Fragment> }

                    {(discount.medical_expense_limit_premium > 0 || discount.personal_injury_limit_premium > 0 || discount.territorial_limits_premium > 0 || discount.indoor_premium > 0 || offersContext.isInFleetFlow()) && <> 
                        <div className="black text-small bold">Additional Coverages</div>
                        {(discount.indoor_premium > 0 || offersContext.isInFleetFlow())&& 
                            <FlexView className="margin-top-small space-between">
                                <div className="black text-tiny">Indoor Coverage</div>
                                {offersContext.isInFleetFlow() ?<div className="black text-tiny">Included</div>
                                :<div className="black text-tiny">{FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}{discount.indoor_premium.toLocaleStringToFixed()}</div>}
                            </FlexView>}
                            
                        {(discount.personal_injury_limit_premium > 0 || offersContext.isInFleetFlow())&& 
                            <FlexView className="margin-top-small space-between">
                                <div className="black text-tiny">{offersContext.isInFleetFlow() ? liabilityLimitPretty(insuranceContext.selectedOption.liabilityLimit) : KPretty(offersContext.personalInjuryCoverage)} Personal Injury Coverage</div>
                                {offersContext.isInFleetFlow() ?<div className="black text-tiny">Included</div>
                                :<div className="black text-tiny">{FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}{discount.personal_injury_limit_premium.toLocaleStringToFixed()}</div>}
                            </FlexView>}
                        {(discount.medical_expense_limit_premium > 0 || offersContext.isInFleetFlow())&& 
                            <FlexView className="margin-top-small space-between">
                                <div className="black text-tiny">{KPretty(offersContext.isInFleetFlow() ? 5000 : offersContext.medicalExpense)} Medical Expenses</div>
                                {offersContext.isInFleetFlow() ?<div className="black text-tiny">Included</div>
                                :<div className="black text-tiny">{FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}{discount.medical_expense_limit_premium.toLocaleStringToFixed()}</div>}
                            </FlexView>}
                        {(discount.territorial_limits_premium > 0 || offersContext.isInFleetFlow()) && 
                            <FlexView className="margin-top-small space-between">
                                {insuranceContext.selectedOption.territorialLimits == WorldWideOption.Custom && <div className="black text-tiny">US and Canada Coverage</div>}
                                {insuranceContext.selectedOption.territorialLimits == WorldWideOption.Worldwide || offersContext.isInFleetFlow() && <div className="black text-tiny">Worldwide Coverage</div>}
                                {offersContext.isInFleetFlow() ?<div className="black text-tiny">Included</div>
                                :<div className="black text-tiny">{FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}{discount.territorial_limits_premium.toLocaleStringToFixed()}</div>}
                            </FlexView>}
                        <Divider />
                    </>}

                    {discount.additional_custom_premium > 0 && <FlexView className="margin-top-small margin-bottom-small space-between">
                        <div className="black text-tiny">Additional Risk</div>
                        <div className="black text-tiny">{FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}{discount.additional_custom_premium.toLocaleStringToFixed()}</div>
                    </FlexView>}

                    {insuranceContext.additionalInsuredList && insuranceContext.additionalInsuredList.length > 0 && 
                        <React.Fragment>
                            <div className="black text-small bold">Additional Insured</div>
                            {insuranceContext.additionalInsuredList.map( (additionalInsured, index) => <div key={index} className="black text-tiny margin-top-small">{additionalInsured.name}</div>)}
                            
                            <Divider />        
                    </React.Fragment>}

                    {/* {discount.hull_coverage_discount > 0 && <DiscountTag title={"Package"} discountPercent={discount.hull_coverage_discount_percent} discountPrice={discount.hull_coverage_discount} />}
                    {discount.hull_coverage_volume_discount > 0 && <DiscountTag title={"Fleet Size"} discountPercent={discount.hull_coverage_volume_discount_percent} discountPrice={discount.hull_coverage_volume_discount} />} */}

                    {discount.taxes > 0 && 
                    <FlexView className="space-between margin-top-small margin-bottom-small">
                        <div className="black text-tiny">{LocalizationService.STRINGS.tax}</div>
                        <div className="black text-tiny">{FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}{discount.taxes}</div>
                    </FlexView> }

                    <FlexView className="space-between">
                        <div className="blue text-body bold">Total Price</div>
                        <div className="blue text-body bold">{FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}{discount.final_price}</div>
                    </FlexView>
                    {FirebaseService.getValue(FirebaseConfigKey.COUNTRY) != COUNTRIES.UK && 
                        <Tooltip title={`You can turn ${!insuranceContext.autoRenew ? 'on' : 'off'} your renewal at any time`} placement="top">
                            <FlexView vAlignContent={'center'} className="margin-top-small">
                            {insuranceContext.selectedOption.billingPeriod === 'Month' &&
                            <AntSwitch onChange={toggleAutoRenew} checked={insuranceContext.autoRenew}></AntSwitch>}
                            <div className="gray text-tiny margin-left-6 margin-bottom-small">Auto renew is {insuranceContext.autoRenew ? 'on' : 'off'}</div>
                            </FlexView>
                        </Tooltip>}
                    {props.mobileExtension && <div className="margin-top-basic">
                        {props.mobileExtension}
                    </div>}
                </Container>
                {!isCanada() && <div className="policy-summary-footer">
                    <Container>
                        <span>Price may vary depending on the state</span>
                    </Container>
                </div>}
            </Paper>
        </React.Fragment>
    )
}